import { AddressSearchResponse } from '@application/components/address-search/AddressSearch';
import { ReportAggregation } from '@domain/graphql.types';
import { createContext } from 'react';
import { SiteLookupFilters } from '../filters/useSiteLookupFilters';
import { SiteLookupDataView } from '../siteLookupDataView';

export type SelectedSite = {
  id: string;
  origin: 'list' | 'map';
};

export type SearchLimit = {
  exceeded: boolean;
  count: number;
};

type SiteLookupContextProps = {
  dataView: SiteLookupDataView;
  downloadReport: (aggregation: ReportAggregation, months: number) => void;
  filters: SiteLookupFilters;
  hasHistoricalAccess: boolean;
  isDownloadingSitesReport: boolean;
  hasRealTimeAccess: boolean;
  maxHistoricalMonths: number;
  recentSearches: AddressSearchResponse[];
  remainingDownloads: number;
  setDataView: (view: SiteLookupDataView) => void;
  updateFilterAddress: (address: AddressSearchResponse) => void;
  updateFilterRadius: (radius: number) => void;
};

const SiteLookupContext = createContext<SiteLookupContextProps>({
  dataView: 'historical',
  downloadReport: () => {},
  filters: { radius: 0 },
  hasHistoricalAccess: false,
  isDownloadingSitesReport: false,
  hasRealTimeAccess: false,
  maxHistoricalMonths: 3,
  recentSearches: [],
  remainingDownloads: 0,
  setDataView: () => {},
  updateFilterAddress: () => {},
  updateFilterRadius: () => {},
});

export default SiteLookupContext;
